import React from 'react';
import { AlertTriangle, CheckCircle } from 'lucide-react';

export default function AlertToast({ message, type = 'warning', position = 'bottom' }) {
  if (!message) return null;

  const isSuccess = type === 'success';
  
  // 🆕 根据 position 参数决定位置
  const positionStyles = position === 'center' 
    ? {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }
    : {
        bottom: '100px', 
        left: '50%',
        transform: 'translateX(-50%)'
      };

  return (
    <div style={{
      position: 'fixed',
      ...positionStyles,
      
      // 样式逻辑
      background: 'rgba(20, 20, 23, 0.95)',
      backdropFilter: 'blur(8px)',
      border: `1px solid ${isSuccess ? 'rgba(74, 222, 128, 0.4)' : 'rgba(234, 179, 8, 0.4)'}`, // 绿框 vs 黄框
      boxShadow: '0 20px 50px rgba(0,0,0,0.8)',
      padding: '16px 24px', //稍微加大一点，更显眼
      borderRadius: '12px',
      color: '#fff',
      fontSize: '14px',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      zIndex: 5000,
      maxWidth: '80vw',
      maxHeight: '60vh',
      overflow: 'auto',
      animation: 'popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
    }}>
      {isSuccess ? (
        <CheckCircle size={24} color="#4ade80" fill="rgba(74, 222, 128, 0.1)" style={{ flexShrink: 0 }} />
      ) : (
        <AlertTriangle size={24} color="#facc15" fill="rgba(250, 204, 21, 0.1)" style={{ flexShrink: 0 }} />
      )}
      <span style={{ 
        color: isSuccess ? '#fff' : '#fef08a', 
        letterSpacing: '0.5px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        lineHeight: '1.5'
      }}>{message}</span>
      
      <style>{`
        @keyframes popIn {
          from { 
            opacity: 0; 
            transform: ${position === 'center' ? 'translate(-50%, calc(-50% + 20px))' : 'translate(-50%, 20px)'} scale(0.9); 
          }
          to { 
            opacity: 1; 
            transform: ${position === 'center' ? 'translate(-50%, -50%)' : 'translate(-50%, 0)'} scale(1); 
          }
        }
      `}</style>
    </div>
  );
}